module.exports = __webpack_public_path__ + "static/media/Prendrelaparoleenpublic.86ecebfc.pdf";